<template>
  <v-layout align-start>
    <v-flex>
      <v-card elevation="0">
        <v-card-title>
          Solicitud de información
          <v-divider vertical inset class="mx-4"></v-divider>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                icon
                large
                color="green"
                @click="listar()"
                v-bind="attrs"
                v-on="on"
                ><v-icon class="fa fa-sync-alt"></v-icon
              ></v-btn>
            </template>
            <span>Actualizar</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-text-field
            v-if="itemSolicitud.length > 0"
            v-model="search"
            label="Buscador"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            dark
            @click="descargarExcel()"
            :disabled="itemSolicitud.length <= 0"
            >Descargar solicitudes</v-btn
          >
        </v-card-title>
        <v-data-table
          v-if="itemSolicitud.length > 0"
          :headers="headers"
          :items="itemSolicitud"
          :search="search"
          no-data-text="No hay datos"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small @click="editItem(item)"> fas fa-eye </v-icon>
          </template>
          <template v-slot:[`item.estado`]="{ item }">
            <v-chip :color="colorEstado(item.estado)">
              <div v-if="item.estado">
                <span>{{ item.estado }}</span>
              </div>
              <div v-else>
                <span>{{ item.estado }}</span>
              </div>
            </v-chip>
          </template>
        </v-data-table>
        <!-- No hay datos -->
        <v-row align="center" justify="center" v-if="itemSolicitud.length <= 0">
          <v-col cols="auto">
            <div class="text-center font-weight-bold display-1">
              Sin datos...
            </div>
            <lottie-player
              src="https://assets9.lottiefiles.com/packages/lf20_dx5nwnnb.json"
              background="transparent"
              speed="1"
              style="width: 250px; height: 250px"
              loop
              autoplay
            ></lottie-player>
          </v-col>
        </v-row>
        <!-- PreLoader -->
        <v-overlay v-model="overlay" z-index="0">
          <lottie-player
            v-if="true"
            src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
            background="transparent"
            speed="1"
            style="width: 300px; height: 300px"
            loop
            autoplay
          ></lottie-player>
        </v-overlay>
        <!-- Detalles de la solicitud -->
        <v-dialog v-model="dialog" max-width="800px" persistent>
          <v-card>
            <v-card-title>
              <span class="text-h5">Detalles de solicitud</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-text-field
                      v-model="fechaSolicitud"
                      label="Fecha solictud"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-text-field
                      v-model="fechaAsistencia"
                      label="Fecha asistencia"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-text-field
                      v-model="numeroAsistencia"
                      label="Numero asistencia"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-text-field
                      v-model="nombre"
                      label="Nombre Asegurado"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-text-field
                      v-model="placa"
                      label="Placa"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-text-field
                      v-model="marca"
                      label="Marca"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="py-0">
                    <v-text-field
                      v-model="modelo"
                      label="Modelo"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="8" class="py-0">
                    <v-text-field
                      v-model="solicitadaNombre"
                      label="Solicitada por nombre"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-textarea
                      v-model="motivoSolicitud"
                      label="Motivo de petición de llamada"
                      outlined
                      auto-grow
                      hide-details
                      readonly
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="py-0">
                    <v-list dense>
                      <v-subheader class="title"
                        >Archivos de la solicitud</v-subheader
                      >
                      <v-list-item-group color="primary">
                        <v-list-item
                          v-for="(item, i) in objArchivosMotivo"
                          :key="i"
                        >
                          <v-list-item-content>
                            <v-list-item-title
                              v-text="item.nombre"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-col>
                  <v-col class="pt-0 pb-5" v-if="objArchivosMotivo.length > 0">
                    <v-btn color="primary" @click="generarZip()"
                      >Descargar archivos</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
              <v-container>
                <v-row>
                  <h2 class="ml-3">Responder a la solicitud</h2>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      v-model="fechaEnvio"
                      label="Fecha de envío"
                      type="datetime-local"
                      step="1"
                      :readonly="readonlyFechaEnvio"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="nombreQuienEnvio"
                      label="Nombre de quien envió"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="estado"
                      :items="itemsEstado"
                      label="Estado"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" v-for="(item, i) in dataSplit" :key="i">
                    <v-textarea
                      v-model="item.seguimiento"
                      :disabled="item.disabled"
                      label="Observaciones"
                      outlined
                      hide-details
                      auto-grow
                      :readonly="readonlyObservaciones"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-btn color="primary" @click="agregarCampo()"
                      >Agregar observacion</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-file-input
                      v-model="archivos"
                      counter
                      label="Seleccione los archivos"
                      multiple
                      outlined
                    >
                      <template v-slot:selection="{ index, text }">
                        <v-chip
                          v-if="index < 2"
                          color="blue darken-4"
                          dark
                          label
                          small
                        >
                          {{ text }}
                        </v-chip>

                        <span
                          v-else-if="index === 2"
                          class="text-overline grey--text text--darken-3 mx-2"
                        >
                          +{{ archivos.length - 2 }} File(s)
                        </span>
                      </template>
                    </v-file-input>
                  </v-col>
                  <v-col cols="12" class="headline">
                    <p>{{ objArchivos.length }} Archivo(s) adjunto(s)</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">
                Cerrar
              </v-btn>
              <v-btn color="blue darken-1" text @click="actualizar()">
                Actualizar
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="generarZip()"
                :disabled="cantidadArchivos <= 0"
              >
                Descargar archivos
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-overlay v-model="loading" z-index="0">
            <lottie-player
              v-if="true"
              src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
              background="transparent"
              speed="1"
              style="width: 300px; height: 300px"
              loop
              autoplay
            ></lottie-player>
          </v-overlay>
        </v-dialog>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { dbRealtimeInformacion, dbStorage, dbRealtimeUsers } from "../main";
import XLSX from "xlsx";
import axios from "axios";
import moment from "moment"

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Opciones",
          value: "actions",
          align: "center",
          sortable: false,
        },
        { text: "Fecha solicitud", value: "fechaSolicitud", align: "center" },
        { text: "Cuenta", value: "cuenta", align: "center" },
        {
          text: "Numero asistencia",
          value: "numeroAsistencia",
          align: "center",
        },
        { text: "Nombre", value: "nombre", align: "center" },
        { text: "Placa", value: "placa", align: "center" },
        { text: "Marca", value: "marca", align: "center" },
        { text: "Modelo", value: "modelo", align: "center" },
        { text: "Estado", value: "estado", align: "center" },
      ],
      itemSolicitud: [],
      respuestaRegional: [],
      dataSplit: [],
      dialog: false,
      messages: 0,
      show: false,
      overlay: false,
      banderaSolicitudWeb: false,
      idUsuario: "",
      fechaSolicitud: "",
      fechaAsistencia: "",
      numeroAsistencia: "",
      nombre: "",
      placa: "",
      marca: "",
      modelo: "",
      motivoSolicitud: "",
      solicitadaNombre: "",
      fechaEnvio: "",
      observaciones: "",
      nombreQuienEnvio: "",
      estado: "",
      cuenta: "",
      itemsEstado: ["En proceso", "Finalizado"],
      archivos: [],
      loading: false,
      banderaFechaNombreBitacora: true,
      readonlyFechaEnvio: false,
      readonlyObservaciones: false,
      //manejo de archivos
      archivosMotivo: [],
      nombreArchivosMotivo: [],
      objArchivosMotivo: [],
      nombreArchivos: [],
      cantidadArchivos: 0,
      objArchivos: [],
      //telegram
      chatIdGrupo: -1001512403640,
      idTelegram: "",
      token: "5024387664:AAGrXKGayYOFsALSYEYkHseAPe2TgZbFjF4",
    };
  },

  created() {
    this.listar();
  },

  methods: {
    listar() {
      let me = this;
      me.overlay = true;
      dbRealtimeInformacion.on("value", function (dataSnapshot) {
        me.itemSolicitud = [];
        dataSnapshot.forEach((value) => {
          value.forEach((value) => {
            me.itemSolicitud.push(value.val());
          });
        });
        me.overlay = false;
      });
    },

    actualizar() {
      let me = this;
      if (
        me.fechaEnvio != null &&
        me.observaciones != null &&
        me.nombreQuienEnvio != null
      ) {
        me.loading = true;
        var seg = "";
        var today = new Date();
        var fecha =
          today.getFullYear() +
          "-" +
          (today.getMonth() + 1) +
          "-" +
          today.getDate() +
          " " +
          new Date().getHours() +
          ":" +
          new Date().getMinutes() +
          ":" +
          new Date().getSeconds() +
          " " +
          this.$store.state.usuario.nombre;

        me.dataSplit.forEach((element) => {
          if (element.nuevoCampo) {
            seg = seg + element.seguimiento + " " + fecha + "~";
          } else {
            seg = seg + element.seguimiento + "~";
          }
        });

        dbRealtimeInformacion
          .child(me.cuenta)
          .child(me.numeroAsistencia)
          .update({
            fechaEnvio: me.fechaEnvio,
            observaciones: seg,
            nombreQuienEnvio: me.nombreQuienEnvio,
            estado: me.estado,
          })
          .then(function () {
            me.notificacionTelegram();
            if (me.archivos.length > 0) {
              me.guardarArchivos();
            } else {
              me.$toast.success("Actualizado con exito");
              me.loading = false;
              me.dialog = false;
              me.limpiar();
            }
          })
          .catch(function (error) {
            console.log(error);
            me.loading = false;
            me.$toast.error("Sucedio algún error");
          });
      } else {
        me.$toast.success("Debe de completar todos los campos");
        me.loading = false;
      }
    },

    guardarArchivos() {
      let me = this;
      for (var i = 0; i < me.archivos.length; i++) {
        dbStorage
          .ref(
            "SolicitudesInformacion/" +
              me.cuenta +
              "/" +
              me.numeroAsistencia +
              "/" +
              me.archivos[i].name
          )
          .put(me.archivos[i])
          .then(function () {
            me.$toast.success("Archivos guardados con exito");
            me.dialog = false;
            me.loading = false;
            me.limpiar();
          })
          .catch(function (error) {
            console.log("ERROR", error);
            me.$toast.error("Sucedio algún error");
            me.loading = false;
          });
      }
    },

    editItem(item) {
      var arrayCadena = [];
      if (item.observaciones) {
        arrayCadena = item.observaciones.split("~");
        arrayCadena.forEach((element) => {
          if (element)
            this.dataSplit.push({
              seguimiento: element,
              disabled: true,
            });
        });
      }

      this.dialog = true;
      this.idUsuario = item.idUsuario;
      this.fechaSolicitud = item.fechaSolicitud;
      this.fechaAsistencia = item.fechaAsistencia;
      this.numeroAsistencia = item.numeroAsistencia;
      this.nombre = item.nombre;
      this.placa = item.placa;
      this.marca = item.marca;
      this.modelo = item.modelo;
      this.motivoSolicitud = item.motivoSolicitud;
      this.solicitadaNombre = item.solicitadaNombre;
      this.fechaEnvio = item.fechaEnvio;
      //this.observaciones = item.observaciones;
      this.nombreQuienEnvio = item.nombreQuienEnvio;
      this.estado = item.estado;
      this.cuenta = item.cuenta;

      this.verificarFechaEnvio();
      this.verificarNombreQuienEnvio(item.nombreQuienEnvio);
      this.verArchivos();
      this.verArchivosMotivo();
    },

    agregarCampo() {
      this.banderaFechaNombreBitacora = true;
      this.observaciones = "";
      this.dataSplit.push({
        seguimiento: null,
        nuevoCampo: true,
      });
    },

    verificarFechaEnvio() {
      if (this.fechaEnvio != null) {
        this.readonlyFechaEnvio = true;
      } else {
        this.readonlyFechaEnvio = false;
      }
    },

    verificarNombreQuienEnvio(usuario) {
      if (usuario == null) {
        this.nombreQuienEnvio = this.$store.state.usuario.nombre;
      }
    },

    limpiar() {
      this.fechaSolicitud = "";
      this.fechaAsistencia = "";
      this.numeroAsistencia = "";
      this.nombre = "";
      this.placa = "";
      this.marca = "";
      this.modelo = "";
      this.motivoSolicitud = "";
      this.solicitadaNombre = "";
      this.fechaEnvio = "";
      this.observaciones = "";
      this.nombreQuienEnvio = "";
      this.estado = "";
      this.cuenta = "";
      this.dataSplit = [];
      this.archivos = [];
      this.objArchivos = [];
      this.cantidadArchivos = 0;
      this.readonlyFechaEnvio = false;
      this.readonlyObservaciones = false;
      this.archivosMotivo = [];
      this.nombreArchivosMotivo = [];
      this.objArchivosMotivo = [];
    },

    close() {
      this.dialog = false;
      this.limpiar();
    },

    colorEstado(item) {
      if (item == "En proceso") {
        return "yellow";
      } else {
        return "green";
      }
    },

    //ver y descargar archivos
    verArchivos() {
      let me = this;
      dbStorage
        .ref("SolicitudesInformacion/" + me.cuenta + "/" + me.numeroAsistencia)
        .list()
        .then(function (refImagen) {
          if (refImagen.items.length > 0) {
            for (var i = 0; i < refImagen.items.length; i++) {
              let aux = refImagen.items[i].location.path.split("/");
              me.nombreArchivos[i] = aux[3];
            }
            me.cantidadArchivos = me.nombreArchivos.length;
            me.descargarArchivos();
          }
        });
    },
    descargarArchivos() {
      let me = this;
      for (var i = 0; i < me.nombreArchivos.length; i++) {
        let auxNombre = me.nombreArchivos[i];
        dbStorage
          .ref(
            "SolicitudesInformacion/" +
              me.cuenta +
              "/" +
              me.numeroAsistencia +
              "/" +
              me.nombreArchivos[i]
          )
          .getDownloadURL()
          .then(function (url) {
            let aux = url;
            me.objArchivos.push({
              nombre: auxNombre,
              url: aux,
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    generarZip() {
      let me = this;
      var FileSaver = require("file-saver");
      var JSZip = require("jszip");
      var zip = new JSZip();
      let archivo = zip.folder("archivos");
      me.loading = true;

      for (var i = 0; i < me.objArchivos.length; i++) {
        let nombre = me.objArchivos[i].nombre;
        let url = me.objArchivos[i].url;
        let contentP = me.downloadURLPromise(url);
        archivo.file(nombre, contentP);
      }
      zip.generateAsync({ type: "blob" }).then(function (content) {
        FileSaver.saveAs(content, "Archivos" + ".zip");
        me.loading = false;
      });
    },

    descargarExcel() {
      let exportData = [];
      for (var i = 0; i < this.itemSolicitud.length; i++) {
        exportData.push({
          "Fecha de informe": this.itemSolicitud[i].fechaSolicitud,
          "Fecha asistencia": this.itemSolicitud[i].fechaAsistencia,
          "Fecha respuesta": this.formatoFecha(this.itemSolicitud[i].fechaEnvio),
          "Numero asistencia": this.itemSolicitud[i].numeroAsistencia,
          Cuenta: this.itemSolicitud[i].cuenta,
          "Nombre asegurado": this.itemSolicitud[i].nombre,
          "Placa vehículo": this.itemSolicitud[i].placa,
          "Marca vehícluo": this.itemSolicitud[i].marca,
          "Modelo vehículo": this.itemSolicitud[i].modelo,
          "Detalle de queja": this.itemSolicitud[i].motivoSolicitud,
          "Reportado por nombre": this.itemSolicitud[i].solicitadaNombre,
          "Fecha resolución": this.itemSolicitud[i].fechaEnvio,
          Observaciones: this.itemSolicitud[i].observaciones,
          "Nombre quien resolvió": this.itemSolicitud[i].nombreQuienEnvio,
          Estado: this.itemSolicitud[i].estado,
        });
      }

      let data = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      const filename = "Solicitudes";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },

    async notificacionTelegram() {
      let me = this;

      let mensaje =
        "SE HA ACTUALIZADO UNA SOLICITUD DE INFORMACION ANTE POSIBLE QUEJA" +
        "%0A" +
        "Fecha solicitud: " +
        me.fechaSolicitud +
        "%0A" +
        "Fecha asistencia: " +
        me.fechaAsistencia +
        "%0A" +
        "Numero asistencia: " +
        me.numeroAsistencia +
        "%0A" +
        "Nombre asegurado: " +
        me.nombre +
        "%0A" +
        "Placa: " +
        me.placa +
        "%0A" +
        "Marca: " +
        me.marca +
        "%0A" +
        "Modelo: " +
        me.modelo +
        "%0A" +
        "Solicitada por nombre: " +
        me.solicitadaNombre +
        "%0A" +
        "motivo de petición: " +
        me.motivoSolicitud;

      await dbRealtimeUsers
        .child(me.idUsuario)
        .once("value")
        .then(function (dataSnapshot) {
          me.idTelegram = dataSnapshot.val().idTelegram;
        })
        .catch(function (error) {
          console.log(error);
        });

      await axios
        .post(
          "https://api.telegram.org/bot" +
            me.token +
            "/sendMessage?chat_id=" +
            me.chatIdGrupo +
            "&text=" +
            mensaje
        )
        .then((response) => {
          //console.log("Mensaje enviado", response.status);
        })
        .catch(function (error) {
          console.log("error", error);
        });

      await axios
        .post(
          "https://api.telegram.org/bot" +
            me.token +
            "/sendMessage?chat_id=" +
            me.idTelegram +
            "&text=" +
            mensaje
        )
        .then((response) => {
          //console.log("Mensaje enviado", response.status);
        })
        .catch(function (error) {
          console.log("error", error);
        });
    },
    formatoFecha(fecha) {
      return moment(fecha).format("YYYY-MM-DD HH:mm:ss");
    },

    //descargar los archivos cargados por la cuenta
    verArchivosMotivo() {
      let me = this;
      me.loading = true;
      dbStorage
        .ref(
          "SolicitudesInformacion/" +
            me.cuenta +
            "/" +
            "ArchivosMotivos" +
            "/" +
            me.numeroAsistencia
        )
        .list()
        .then(function (refImagen) {
          if (refImagen.items.length > 0) {
            me.loading = false;
            for (var i = 0; i < refImagen.items.length; i++) {
              let aux = refImagen.items[i].location.path.split("/");
              me.nombreArchivosMotivo[i] = aux[4];
            }
            me.descargarArchivosMotivo();
          } else {
            me.loading = false;
          }
        })
        .catch(function (error) {
          console.log(error);
          me.loading = false;
        });
    },
    descargarArchivosMotivo() {
      let me = this;
      for (var i = 0; i < me.nombreArchivosMotivo.length; i++) {
        let auxNombre = me.nombreArchivosMotivo[i];
        dbStorage
          .ref(
            "SolicitudesInformacion/" +
              me.cuenta +
              "/" +
              "ArchivosMotivos" +
              "/" +
              me.numeroAsistencia +
              "/" +
              me.nombreArchivosMotivo[i]
          )
          .getDownloadURL()
          .then(function (url) {
            let aux = url;
            me.objArchivosMotivo.push({
              nombre: auxNombre,
              url: aux,
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    generarZip() {
      let me = this;
      var FileSaver = require("file-saver");
      var JSZip = require("jszip");
      var zip = new JSZip();
      let archivo = zip.folder("Archivos motivo");
      me.loading = true;

      for (var i = 0; i < me.objArchivosMotivo.length; i++) {
        let nombre = me.objArchivosMotivo[i].nombre;
        let url = me.objArchivosMotivo[i].url;
        let contentP = me.downloadURLPromise(url);
        archivo.file(nombre, contentP);
      }
      zip.generateAsync({ type: "blob" }).then(function (content) {
        FileSaver.saveAs(content, "Archivos" + ".zip");
        me.loading = false;
      });
    },
    downloadURLPromise(url) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.onreadystatechange = function (evt) {
          if (xhr.readyState === 4) {
            if (xhr.status == 200) {
              resolve(xhr.response);
            } else {
              reject(new Error("Error" + ":" + xhr.status));
            }
          }
        };
        xhr.send();
      });
    },
  },
};
</script>
<style scoped>
.texto {
  text-align: center;
  align-content: center;
}
</style>
